import { Expose, Type } from 'class-transformer';

import { SnModel } from '@lib/common/models';

import { SnOrganization } from '../organization';
import { SnTeam } from '../team';
import { SnUser } from '../user';

export class FsRecordingDownloadMeta extends SnModel {
  @Expose()
  public id: string;

  @Expose()
  public vaultIncidents: any;

  @Expose()
  public source: number;

  @Expose()
  public speed: number;

  @Expose()
  public downloadStatus: number;

  @Expose()
  @Type(() => SnOrganization)
  public organization: SnOrganization;

  @Expose()
  @Type(() => SnUser)
  public user: SnUser;

  @Expose()
  public team: SnTeam;

  @Expose()
  public sha256Hash: string;

  @Expose()
  public createdTimestamp: Date;

  @Expose()
  public updatedTimestamp: Date;

  @Expose()
  public integrationMeta: any;

  @Expose()
  public retryTimes: number;

  @Expose()
  public meta: Date;

  @Expose()
  public filesize: number;

  @Expose()
  public details: string;

  @Expose()
  public checksum: string;

  @Expose()
  public geometry: any;

  @Expose()
  public altitude: number;

  @Expose()
  public heading: number;

  @Expose()
  public usngCoord: string;

  @Expose()
  public address: string;

  @Expose()
  public city: string;

  @Expose()
  public state: string;

  @Expose()
  public zip: string;

  @Expose()
  public batteryStart: number;

  @Expose()
  public batteryEnd: number;

  @Expose()
  public deviceOrientation: string;

  @Expose()
  public appVersion: string;

  @Expose()
  public osName: string;

  @Expose()
  public osVersion: string;

  @Expose()
  public startTimestamp: string;

  @Expose()
  public endTimestamp: string;

  @Expose()
  public heartbeatTimestamp: string;

  @Expose()
  public period: string;

  @Expose()
  public expirationDate: string;

  @Expose()
  public shareLivestreamWithParent: boolean;

  @Expose()
  public confidential: boolean;

  @Expose()
  public camera: string;

  constructor(data: any = {}) {
    super();
    this.fromJSON(data);
  }
}
